import { Environment } from "@/types/environment";

const production: Environment = {
    api: {
        enterprise: 'CGMP',
        baseUri: "https://api.paguefreeflow.com.br/webapi",
        baseUriAuth: "https://api.pedagiodigital.com",
        apiKeyAuth: "fsPj1oWQFp1gk43fIb6F24wR9aNi0pmV29oMNNk2", // TODO: verificar o prod
        companyIdentification: "CGMP",
        channel: "16",
        automaticChannel: "16",
        userIdentification: "ffap",
        merchantDefinedInformation: {
            channel: "APP-RecargaPreManual"
        },
        cybersource: {
            orgId: "k8vif92e",
            merchantId: "semparar_br",
        },
        prefix: "ff-",
        hashKey: 'f5c5caf521f2f63230cf741b6dc1543c8ebb2881',
        loginVersion: "v1",
        app: 'PagueFF',
    },
    pci: {
        url: 'https://cyptgw.fleetcor.com.br',
        key: '99374fbe8588c6cb1fc1a04ccf0f38617ef72d3b2526393830a3dadd36462d87',
    },
    recaptcha: {
        siteKey: "6Le60qMrAAAAAFWEDb3P14KuOMxYqV3EziFbO6NK"
    },
}

export default production;